// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@tps/XDL/types";

export default {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: [0, 481, 769, 1025, 1366],
    maxWidths: [480, 768, 1024, 1366, 1366],
    paddingValues: [16, 16, 16, 16, 16],
    containerPadding: ["0 16px", "0 16px", "0 16px", "0 16px", "0 16px"],
} as xBaseTheme["breakpoints"];
